import React from 'react';
import styled from 'styled-components';
import { ITsaReportState } from '../../../data/providers/reports/tsaReportProvider';
import { Entity } from '../../../data/types';
import { Column } from '../../layout/Column';
import { Card } from '../../shared/card/Card';
import { CardBody } from '../../shared/card/CardBody';
import { GraphContainer } from '../../shared/graphs/GraphContainer';
import { Icon } from '../../shared/Icon';
import { Notable } from '../../shared/pdf/Notable';
import { EPdfMode, isPdf, shouldInvert } from '../../shared/pdf/Pdf';
import { TsaGraph } from './TsaGraph';

interface IProps {
  reportState: ITsaReportState;
  pdfMode?: EPdfMode;
  quartileColors: string[];
  entity: Entity;
}

export const TsaGraphCard = (props: IProps): React.ReactElement => {
  return (
    <PdfCardWrapper className='avoid-break' pdf={isPdf(props.pdfMode)}>
      <Notable pdf={isPdf(props.pdfMode)}>
        <Card inverse={shouldInvert(props.pdfMode)} noTopRadius>
          <Column>
            <CardBody withoutFooter>
              <GraphContainer inverse={shouldInvert(props.pdfMode)}>
                {/* <PopulationInfo
                  entity={props.entity}
                  populationData={props.reportState.comparisonPopulation}
                  populationSettings={props.reportState.comparisonPopulation}
                /> */}
                <TsaGraph
                  reportState={props.reportState}
                  pdfMode={props.pdfMode}
                  quartileColors={props.quartileColors}
                />
              </GraphContainer>
            </CardBody>
          </Column>
        </Card>
      </Notable>
    </PdfCardWrapper>
  );
};

const PdfCardWrapper = styled.div<{ pdf?: boolean }>`
  flex: 1;
`;

interface IPopulationInfoProps {
  populationData: ITsaReportState['comparisonPopulation'];
  populationSettings: ITsaReportState['comparisonPopulation'];
  entity: Entity;
}

// const PopulationInfo = (props: IPopulationInfoProps): React.ReactElement => {
//   const entityLabel =
//     props.populationSettings.entity.value !== 'self'
//       ? props.populationSettings.entity.label
//       : props.entity.name;

//   return (
//     <Container>
//       <Column>
//         <Container>
//           <Icon
//             name='add'
//             size='small'
//             style={{ color: 'var(--color-primary)' }}
//           />
//           <div style={{ flex: 1, whiteSpace: 'nowrap' }}>{entityLabel}</div>
//         </Container>
//       </Column>
//     </Container>
//   );
// };

const Container = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
`;
